import React from 'react';
import PropTypes from 'prop-types';

import StyleButton from './style_button';

const BLOCK_TYPES = [
  { label: 'UL', style: 'unordered-list-item', icon: 'icon-custom-list-ul' },
  { label: 'OL', style: 'ordered-list-item', icon: 'icon-custom-list-ol' },
];

const BlockStyleControls = ({ editorState, onToggle }) => {
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  return (
    <div className="RichEditor-controls">
      {BLOCK_TYPES.map((type) =>
        <StyleButton
          key={type.label}
          active={type.style === blockType}
          label={type.label}
          icon={type.icon}
          onToggle={onToggle}
          style={type.style}
        />
      )}
    </div>
  );
};

BlockStyleControls.propTypes = {
  editorState: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default BlockStyleControls;
